var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.objectLoaded)?_c('base-tab-card',_vm._g({attrs:{"tabs":_vm.tabs,"title":_vm.title}},_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }